import { useContext } from 'react';

import { ModuleFilterContext } from './ModuleFilter.context';
import type { IModuleFilterProvider } from './ModuleFilter.types';

const useModuleFilter = (): IModuleFilterProvider => {
	const ctx = useContext(ModuleFilterContext);

	if (!ctx) throw new Error('useModuleFilter must be used inside <ModuleFilterProvider />');
	return ctx;
};

export default useModuleFilter;
